import React, { Component } from 'react';
import { User, UserCalculator, Vacation } from 'salary-shared';
import { filter, sumBy } from 'lodash';

import './UserRow.scss';

export interface UserRowProps {
	year: string;
	user: User;
	vacations: Vacation[];
}

export interface UserRowState {
}

export class UserRow extends Component<UserRowProps, UserRowState> {
	render() {
		const { year, user, vacations } = this.props;
		const eoYear = `${year}-12-31`;
		const days = UserCalculator.vacationDays(user, eoYear);
		const used = sumBy(vacations, 'days');

		function _used(month: string): string {
			const res = sumBy(
				filter(vacations, v => `${year}-${month}` === v.date),
				'days',
			);
			if (res > 0) {
				return '' + res;
			} else {
				return '';
			}
		}

		return (
			<tr className={`UserRow ${(days - used < 0) ? 'UserRow--error' : ''}`}>
				<td className='UserRow__td--user'>{user.name}</td>
				<td className='UserRow__td--start'>{user.start}</td>
				<td className='UserRow__td--seniority'>{UserCalculator.seniority(user, eoYear)}</td>
				<td className='UserRow__td--days'>{days}</td>
				<td className='UserRow__td--month'>{_used('01')}</td>
				<td className='UserRow__td--month'>{_used('02')}</td>
				<td className='UserRow__td--month'>{_used('03')}</td>
				<td className='UserRow__td--month'>{_used('04')}</td>
				<td className='UserRow__td--month'>{_used('05')}</td>
				<td className='UserRow__td--month'>{_used('06')}</td>
				<td className='UserRow__td--month'>{_used('07')}</td>
				<td className='UserRow__td--month'>{_used('08')}</td>
				<td className='UserRow__td--month'>{_used('09')}</td>
				<td className='UserRow__td--month'>{_used('10')}</td>
				<td className='UserRow__td--month'>{_used('11')}</td>
				<td className='UserRow__td--month'>{_used('12')}</td>
				<td className='UserRow__td--used'>{used}</td>
				<td className='UserRow__td--left'>{days - used}</td>
			</tr>
		);
	}
}
